import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from 'antd'

import { icons, ColourButton, Spacer, Label } from 'portal/lib/primitives'

export function RestoreButton({
  children = 'Restore',
  iconOnly = false,
  ...props
}) {
  if (iconOnly) {
    return (
      <Tooltip title={children}>
        <ColourButton.BasicBorderless
          id="RestoreButton"
          style={{ padding: '4px 8px', borderRadius: '50%' }}
          {...props}
        >
          <icons.Restore />
        </ColourButton.BasicBorderless>
      </Tooltip>
    )
  }

  return (
    <ColourButton.BasicBorderless id="RestoreButton" {...props}>
      <icons.Restore colour="currentColor" />

      <Spacer.Fine />

      <Label isChild colour="inherit">
        {children}
      </Label>
    </ColourButton.BasicBorderless>
  )
}

RestoreButton.propTypes = {
  ...ColourButton.Negative.propTypes,
  children: PropTypes.string
}
